import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success-100 text-success-500" };
const _hoisted_2 = { class: "!ml-3" };
const _hoisted_3 = { class: "inline-flex h-6 w-6 items-center justify-center rounded-full bg-primary-100" };
const _hoisted_4 = { class: "hl-text-sm-medium !ml-3" };
import { CheckIcon, ChevronDownIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FeaturesList',
    props: {
        features: {
            type: Array,
            required: true,
        },
        columns: {
            type: Number,
            default: 1,
        },
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const showMoreFeatures = ref(false);
        const featuresToShow = computed(() => {
            const features = props.features;
            if (features.length > 6 && !showMoreFeatures.value) {
                return features.slice(0, 5);
            }
            else
                return features;
        });
        const gridClasses = computed(() => {
            if (props.columns === 1)
                return 'grid-cols-1';
            else
                return 'grid-cols-2 gap-x-8';
        });
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["hl-text-md-regular grid overflow-auto", [gridClasses.value]]),
                style: _normalizeStyle({ maxHeight: `${216 / __props.columns}px` })
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuresToShow.value, (feature, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "!mt-3 flex items-center"
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_unref(CheckIcon), { class: "h-4 w-4" })
                        ]),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(feature.label), 1 /* TEXT */)
                    ]));
                }), 128 /* KEYED_FRAGMENT */)),
                (((_a = __props.features) === null || _a === void 0 ? void 0 : _a.length) > 6)
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 0,
                        id: "ShowMoreFeaturesButton",
                        text: "",
                        class: "!mt-3",
                        onClick: _cache[0] || (_cache[0] = ($event) => (showMoreFeatures.value = !showMoreFeatures.value))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(ChevronDownIcon), {
                                    class: _normalizeClass(["h-4 w-4", { 'rotate-180': showMoreFeatures.value }])
                                }, null, 8 /* PROPS */, ["class"])
                            ]),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(showMoreFeatures.value ? _unref(t)('common.show_less') : _unref(t)('common.show_more')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }))
                    : _createCommentVNode("v-if", true)
            ], 6 /* CLASS, STYLE */));
        };
    }
});
